var _rect, _rect2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.583496,
    y: 19.9538,
    width: 61.4167,
    height: 2.76721,
    fill: "url(#paint0_linear_45_1417)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.583496,
    y: 40.2466,
    width: 61.4167,
    height: 2.76721,
    fill: "url(#paint1_linear_45_1417)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3418 62L19.9538 0.583305L25.4882 0.583305L20.8762 62L15.3418 62Z",
    fill: "url(#paint2_linear_45_1417)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6348 62L41.1692 0.583305L46.7036 0.583305L41.1692 62L35.6348 62Z",
    fill: "url(#paint3_linear_45_1417)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_1417",
    x1: 0.583496,
    y1: 22.721,
    x2: 62.0002,
    y2: 22.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_1417",
    x1: 62.3845,
    y1: 41.5488,
    x2: 0.583496,
    y2: 41.5488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_1417",
    x1: 20.8762,
    y1: 62,
    x2: 20.8762,
    y2: 0.583305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_1417",
    x1: 38.239,
    y1: 0.198978,
    x2: 38.239,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.88a0b78d607f47e1f31800ad4cb11ffc.svg";
export { ForwardRef as ReactComponent };